/**
 * Manipula los datos de la llamada, en este caso, detectamos el tipo de landing y en función de eso se carga uno u otro script
 */

import { minimizedDSA, scrollToDSA, newPuertas} from '../helpers/handleDSA'

const DICTIONARY_CASES = {
  DSA_ACTIVE: 'dsa-active',
  DSA_INACTIVE: 'dsa-inactive',
  DSA_RIGHT: 'dsa-right',
  DSA_LEFT: 'dsa-left',
  SCROLL_RIGHT_1: '1-scroll-right',
  SCROLL_RIGHT_2: '2-scroll-right',
  SCROLL_LEFT_1: '1-scroll-left',
  SCROLL_LEFT_2: '2-scroll-left',
  MINIMIZED_RIGHT: 'minimized-right',
  MINIMIZED_LEFT: 'minimized-left',
  MINIMIZED_LEFT_OPEN: 'minimized-left-open',
  MINIMIZED_RIGHT_OPEN: 'minimized-right-open',
  DSA_ACTIVE_OPEN: 'dsa-active-open',
  DSA_ACTIVE_CA: 'dsa-active-ca',
  DSA_ACTIVE_MABA: 'dsa-active-maba',
  DSA_ACTIVE_CABA: 'dsa-active-caba',
}

const DSA_STATE = Object.freeze({
  ON: 'on',
  ON_LEFT: 'on-left',
  OFF: 'off',
  ON_NEW: 'on-new',
  ON_CA: 'on-ca',
  ON_MABA: 'on-maba',
  ON_CABA: 'on-caba'
})

const toggleDSA = (state) => {
  window.DATALAYER_IFP = {
    action: state
  }
}

export function handleResponse(data) {
  console.info(JSON.parse(data.value))

  const { action } = JSON.parse(data.value)

  if (action === DICTIONARY_CASES.DSA_ACTIVE) {
    toggleDSA(DSA_STATE.ON)

    console.info(`ACCIONES PARA ${DICTIONARY_CASES.DSA_ACTIVE}`)
    return
  }
  if (action === DICTIONARY_CASES.DSA_ACTIVE_OPEN) {
    toggleDSA(DSA_STATE.ON_NEW)
    minimizedDSA()
    // newModalGrupo()
    // newPuertas()

    console.info(`ACCIONES PARA ${DICTIONARY_CASES.DSA_ACTIVE_OPEN}`)
    return
  }
  if (action === DICTIONARY_CASES.DSA_ACTIVE_MABA) {
    toggleDSA(DSA_STATE.ON_MABA)
    minimizedDSA()
    console.info(`ACCIONES PARA ${DICTIONARY_CASES.DSA_ACTIVE_MABA}`)
    return
  }
  if (action === DICTIONARY_CASES.DSA_ACTIVE_CABA) {
    toggleDSA(DSA_STATE.ON_CABA)
    minimizedDSA()
    console.info(`ACCIONES PARA ${DICTIONARY_CASES.DSA_ACTIVE_CABA}`)
    return
  }
  if (action === DICTIONARY_CASES.DSA_ACTIVE_CA) {
    toggleDSA(DSA_STATE.ON_CA)
    minimizedDSA()
    // newModalGrupo()
    // newPuertas()

    console.info(`ACCIONES PARA ${DICTIONARY_CASES.DSA_ACTIVE_CA}`)
    return
  }

  if (action === DICTIONARY_CASES.DSA_INACTIVE) {
    toggleDSA(DSA_STATE.OFF)

    console.info(`ACCIONES PARA ${DICTIONARY_CASES.DSA_INACTIVE}`)
    return
  }

  if (action === DICTIONARY_CASES.DSA_RIGHT) {
    toggleDSA(DSA_STATE.ON)

    console.info(`ACCIONES PARA ${DICTIONARY_CASES.DSA_RIGHT}`)
    return
  }

  if (action === DICTIONARY_CASES.DSA_LEFT) {
    toggleDSA(DSA_STATE.ON_LEFT)

    console.info(`ACCIONES PARA ${DICTIONARY_CASES.DSA_LEFT}`)
    return
  }

  if (action === DICTIONARY_CASES.SCROLL_RIGHT_1) {
    toggleDSA(DSA_STATE.ON)
    scrollToDSA(100)

    console.info(`ACCIONES PARA ${DICTIONARY_CASES.SCROLL_RIGHT_1}`)
    return
  }

  if (action === DICTIONARY_CASES.SCROLL_RIGHT_2) {
    toggleDSA(DSA_STATE.ON)
    scrollToDSA(200)
    console.info(`ACCIONES PARA ${DICTIONARY_CASES.SCROLL_RIGHT_2}`)
    return
  }

  if (action === DICTIONARY_CASES.SCROLL_LEFT_1) {
    toggleDSA(DSA_STATE.ON_LEFT)
    scrollToDSA(100)

    console.info(`ACCIONES PARA ${DICTIONARY_CASES.SCROLL_LEFT_1}`)
    return
  }

  if (action === DICTIONARY_CASES.SCROLL_LEFT_2) {
    toggleDSA(DSA_STATE.ON_LEFT)
    scrollToDSA(200)
    console.info(`ACCIONES PARA ${DICTIONARY_CASES.SCROLL_LEFT_2}`)
    return
  }

  if (action === DICTIONARY_CASES.MINIMIZED_RIGHT) {
    scrollToDSA(0, true)
    console.info(`ACCIONES PARA ${DICTIONARY_CASES.MINIMIZED_RIGHT}`)
    return
  }

  if (action === DICTIONARY_CASES.MINIMIZED_LEFT) {
    toggleDSA(DSA_STATE.ON_LEFT)
    scrollToDSA(0, true)
    console.info(`ACCIONES PARA ${DICTIONARY_CASES.MINIMIZED_LEFT}`)
    return
  }

  if (action === DICTIONARY_CASES.MINIMIZED_LEFT_OPEN) {
    toggleDSA(DSA_STATE.ON_LEFT)
    minimizedDSA()
    console.info(`ACCIONES PARA ${DICTIONARY_CASES.MINIMIZED_LEFT_OPEN}`)
    return
  }

  if (action === DICTIONARY_CASES.MINIMIZED_RIGHT_OPEN) {
    toggleDSA(DSA_STATE.ON)
    minimizedDSA()
    console.info(`ACCIONES PARA ${DICTIONARY_CASES.MINIMIZED_RIGHT_OPEN}`)
  }
}


var urlActual = window.location.href;
  var urls = [
    "https://www.ifp.es/ca/qui-som",
    "https://www.ifp.es/ca/projecte-educatiu",
    "https://www.ifp.es/ca/empreses",
    "https://www.ifp.es/ca/beques-i-ajuts",
    "https://www.ifp.es/ca/els-nostres-centres",
    "https://www.ifp.es/ca/avantatges-dels-nostres-alumnes",
    "https://www.ifp.es/ca/opinions",
    "https://www.ifp.es/ca/premis-i-reconeixements",
    "https://www.ifp.es/ca/preguntes-frequents"
  ];

  if (urls.includes(urlActual)) {
    var checkExist = setInterval(function() {
      var elemento = document.getElementById("dsa-newId");
      if (elemento) {
        elemento.style.display = "none";
        clearInterval(checkExist); 
      }
    }, 100); 
  }